// extracted by mini-css-extract-plugin
module.exports = {"resultWrapper":"result_resultWrapper__19ET7","successTitle":"result_successTitle__2t2lm","resultSubTitle":"result_resultSubTitle__29mSa","vegMarquee":"result_vegMarquee__2ISZb"};